export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const LIST = '/list';
export const PASSWORD_FORGET = '/forgot-password';
export const ADMIN = '/admin';